import { Tab, Tabs, Rating } from "@mui/material";
import { useEffect, useState } from "react";
import { Row, Col, Input } from "reactstrap";
import { Button } from "reactstrap/lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, useIntl } from "react-intl";

import styled from "styled-components";

function APLRatingModal({
  questionsToDelete,
  setQuestionsToDelete,
  setNewStudentQuestions,
  setNewSupervisorQuestions,
  newStudentQuestions,
  newSupervisorQuestions,
  answeredStudentQuestionIds,
  answeredSupervisorQuestionIds,
}) {
  const intl = useIntl();
  const [level, setLevel] = useState(false);
  const [toggledQuestion, setToggledQuestion] = useState(-1);

  useEffect(() => {
    setLevel("student");
  }, []);

  if (!newStudentQuestions || !newSupervisorQuestions) {
    return null;
  }
  const renderQuestions = (questionGroup) => {
    switch (questionGroup) {
      case "student":
        return (
          <div>
            {newStudentQuestions.map((question, index) => {
              const isAnswered = answeredStudentQuestionIds?.has(question.id);
              return (
                <Row
                  key={"studQ" + index}
                  className="apl-question my-2 p-2 align-items-start"
                >
                  <Col lg={10}>
                    {isAnswered ? (
                      <>
                        <p
                          style={{
                            margin: 0,
                            padding: "4px 6px",
                            cursor: "default",
                          }}
                          title={intl.formatMessage({
                            id: "QuestionHasAnswersCannotBeEdited",
                          })}
                        >
                          {question.question}
                          <FontAwesomeIcon
                            icon="lock"
                            className="ms-2 text-muted"
                            size="sm"
                          />
                        </p>
                        <Rating
                          name="simple-controlled"
                          value={question.responseRange}
                          max={5}
                          readOnly
                        />
                      </>
                    ) : (
                      <>
                        {toggledQuestion === index ? (
                          <div>
                            <Input
                              autoFocus
                              onClick={() => setToggledQuestion(index)}
                              onKeyDown={(event) => {
                                if (
                                  event.key === "Enter" ||
                                  event.key === "Escape"
                                ) {
                                  setToggledQuestion(-1);
                                  event.preventDefault();
                                  event.stopPropagation();
                                }
                              }}
                              onChange={(e) => {
                                var tempQuestionArray = [
                                  ...newStudentQuestions,
                                ];
                                tempQuestionArray[index].question =
                                  e.target.value;
                                setNewStudentQuestions(tempQuestionArray);
                              }}
                              type="text"
                              value={question.question}
                            />
                          </div>
                        ) : (
                          <TextHover
                            className="apl-question-edit"
                            onClick={() => setToggledQuestion(index)}
                            title={intl.formatMessage({
                              id: "ClickToEditQuestion",
                            })}
                          >
                            {question.question}
                          </TextHover>
                        )}
                        <Rating
                          name="simple-controlled"
                          value={question.responseRange}
                          max={5}
                          onChange={(event, newValue) => {
                            var ratingQuestions = [...newStudentQuestions];
                            ratingQuestions[index].responseRange = newValue;
                            setNewStudentQuestions(ratingQuestions);
                          }}
                        />
                      </>
                    )}
                  </Col>
                  <Col
                    lg={2}
                    className="d-flex justify-content-end align-items-start"
                  >
                    <Button
                      color="danger"
                      outline
                      size="sm"
                      className="mt-1"
                      onClick={() => {
                        var ratingQuestions;
                        if (question.id) {
                          ratingQuestions = [...questionsToDelete];
                          ratingQuestions.push(question);
                          setQuestionsToDelete(ratingQuestions);
                        }
                        ratingQuestions = [...newStudentQuestions];
                        ratingQuestions.splice(index, 1);
                        setNewStudentQuestions(ratingQuestions);
                      }}
                    >
                      <FontAwesomeIcon icon="trash-can" />
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </div>
        );
      case "supervisor":
        return (
          <div>
            {newSupervisorQuestions.map((question, index) => {
              const isAnswered = answeredSupervisorQuestionIds?.has(
                question.id,
              );
              return (
                <Row
                  key={"supQ" + index}
                  className="apl-question my-2 p-2 align-items-start"
                >
                  <Col>
                    {isAnswered ? (
                      <>
                        <p
                          style={{
                            margin: 0,
                            padding: "4px 6px",
                            cursor: "default",
                          }}
                          title={intl.formatMessage({
                            id: "QuestionHasAnswersCannotBeEdited",
                          })}
                        >
                          {question.question}
                          <FontAwesomeIcon
                            icon="lock"
                            className="ms-2 text-muted"
                            size="sm"
                          />
                        </p>
                        <Rating
                          name="simple-controlled"
                          value={question.responseRange}
                          max={5}
                          readOnly
                        />
                      </>
                    ) : (
                      <>
                        {toggledQuestion === index ? (
                          <div>
                            <Input
                              autoFocus
                              onKeyDown={(event) => {
                                if (
                                  event.key === "Enter" ||
                                  event.key === "Escape"
                                ) {
                                  setToggledQuestion(-1);
                                  event.preventDefault();
                                  event.stopPropagation();
                                }
                              }}
                              onChange={(e) => {
                                var tempQuestionArray = [
                                  ...newSupervisorQuestions,
                                ];
                                tempQuestionArray[index].question =
                                  e.target.value;
                                setNewSupervisorQuestions(tempQuestionArray);
                              }}
                              type="text"
                              value={question.question}
                            />
                            <br />
                          </div>
                        ) : (
                          <TextHover
                            className="apl-question-edit"
                            onClick={() => setToggledQuestion(index)}
                            title={intl.formatMessage({
                              id: "ClickToEditQuestion",
                            })}
                          >
                            {question.question}
                          </TextHover>
                        )}
                        <Rating
                          name="simple-controlled"
                          value={question.responseRange}
                          max={5}
                          onChange={(event, newValue) => {
                            var ratingQuestions = [...newSupervisorQuestions];
                            ratingQuestions[index].responseRange = newValue;
                            setNewSupervisorQuestions(ratingQuestions);
                          }}
                        />
                      </>
                    )}
                  </Col>
                  <Col
                    lg={2}
                    className="d-flex justify-content-end align-items-start"
                  >
                    <Button
                      color="danger"
                      outline
                      size="sm"
                      className="mt-1"
                      onClick={() => {
                        if (question.id) {
                          var ratingQuestions;
                          ratingQuestions = [...questionsToDelete];
                          ratingQuestions.push(question);
                          setQuestionsToDelete(ratingQuestions);
                        }
                        ratingQuestions = [...newSupervisorQuestions];
                        ratingQuestions.splice(index, 1);
                        setNewSupervisorQuestions(ratingQuestions);
                      }}
                    >
                      <FontAwesomeIcon icon="trash-can" />
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </div>
        );
      default:
        return null;
    }
  };

  const handleChange = (event, newValue) => {
    setToggledQuestion(-1);
    setLevel(newValue);
  };

  return (
    <div
      onClick={(event) => {
        if (toggledQuestion !== -1 && event.target.type !== "text") {
          setToggledQuestion(-1);
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    >
      <Tabs value={level} onChange={handleChange}>
        <Tab
          label={<FormattedMessage id="Student" />}
          value="student"
          icon={<FontAwesomeIcon icon="user" />}
          iconPosition="start"
        />
        <Tab
          label={<FormattedMessage id="Supervisor" />}
          value="supervisor"
          icon={<FontAwesomeIcon icon="user-tie" />}
          iconPosition="start"
        />
      </Tabs>
      {renderQuestions(level)}
      <Button
        className="mt-2"
        color="primary"
        outline
        onClick={() => {
          if (level === "student") {
            var newQuestion;
            let temp = [...newStudentQuestions];
            newQuestion = {
              question: intl.formatMessage({
                id: "DefaultAplQuestionText",
              }),
              responseRange: 5,
            };
            temp.push(newQuestion);
            setNewStudentQuestions(temp);
          } else if (level === "supervisor") {
            let temp = [...newSupervisorQuestions];
            newQuestion = {
              question: intl.formatMessage({
                id: "DefaultAplQuestionText",
              }),
              responseRange: 5,
            };
            temp.push(newQuestion);
            setNewSupervisorQuestions(temp);
          }
        }}
      >
        <FontAwesomeIcon icon="plus" className="me-2" />
        <FormattedMessage id="AddQuestion" />
      </Button>
    </div>
  );
}

export default APLRatingModal;

var TextHover = styled.p`
  width: fit-content;
  padding: 4px 6px;
  margin: 0;
  border-radius: 4px;

  &:hover {
    border: 1px solid lightgrey;
  }
`;
